<ng-container *ngIf="visivel">

  <!-- destaque: topo do hub -->
  <section class="bn bn--destaque" *ngIf="formato === 'destaque' && !garantido" aria-label="Prêmio por concluir os primeiros passos">
    <span class="bn-ic"><i class="fas fa-gift"></i></span>
    <div class="bn-corpo">
      <span class="bn-rot">Prêmio por concluir</span>
      <b class="bn-valor">{{ valor }} de desconto</b>
      <span class="bn-onde">na sua primeira mensalidade</span>
      <span class="bn-meta"><b>{{ textoFaltam }}</b> · {{ textoDias }}</span>
      <span class="bn-como">Como ganhar: faça os 6 passos e conclua o pedido de teste antes de acabar o teste grátis. O desconto entra sozinho quando você assinar.</span>
    </div>
  </section>

  <section class="bn bn--destaque bn--ok" *ngIf="formato !== 'faixa' && garantido">
    <span class="bn-ic"><i class="fas fa-check"></i></span>
    <div class="bn-corpo">
      <span class="bn-rot">Prêmio garantido</span>
      <b class="bn-valor">{{ valor }} de desconto</b>
      <span class="bn-onde">na sua primeira mensalidade. Entra sozinho quando você assinar.</span>
    </div>
  </section>

  <!-- faixa: alto de cada passo -->
  <div class="bn bn--faixa" *ngIf="formato === 'faixa' && !garantido">
    <i class="fas fa-gift"></i>
    <span><b>{{ valor }} de desconto</b> na primeira mensalidade ao concluir · {{ textoFaltam.toLowerCase() }} · {{ textoDias }}</span>
  </div>

  <!-- final: junto do botão de concluir o pedido de teste -->
  <div class="bn bn--final" *ngIf="formato === 'final' && !garantido">
    <i class="fas fa-gift"></i>
    <span>Concluindo agora você garante <b>{{ valor }} de desconto</b> na primeira mensalidade.</span>
  </div>
</ng-container>
